import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './savebookLoader.css';

export const SavebookLoader = (props) => {
  const {
    lang,
    weddingTextStatus,
  } = props;

  if (weddingTextStatus) {
    return (
      <div className="saveBookLoader">
        <div className="center">
          <div className="sk-chasing-dots">
            <div className="sk-child sk-dot1" />
            <div className="sk-child sk-dot2" />
          </div>
          <p>{lang.generateInProgress}</p>
        </div>
      </div>
    );
  }
  return null;
};

SavebookLoader.defaultProps = {
  lang: {},
  weddingTextStatus: false,
};

SavebookLoader.propTypes = {
  lang: PropTypes.object,
  weddingTextStatus: PropTypes.bool,
};


export default connect(state => ({
  weddingTextStatus: state.editorUI.setWeddingTextStatus,
}))(SavebookLoader);



// WEBPACK FOOTER //
// ./src/components/savebook-loader/savebookLoader.jsx